export class BrokerMaster {
  public BROKER_ID!: number;
  public BROKER_NAME!: string;
  public BROKER_ADD!: string;
  public LOC_CODE!: string;
  public BANK_AC!: string;
  public BANK_NAME!: string;
  public IFSC!: string;
  public BANK_BRANCH!: string;
  public CREATEDBY_USERID!: Number;
  public UPDATEDBY_USERID!: Number;
  public CREATED_DATE!: Date;
  public UPDATED_DATE!: Date;
  public IS_ACTIVE!: boolean;
  public LOC_NAME!: string;
}
